import { createContext, useContext, useState, useCallback } from "react";
import { AddSheet } from "@/components/add/AddSheet";

const Ctx = createContext({ openAdd: () => {}, close: () => {} });
export const useAddSheet = () => useContext(Ctx);

export function AddSheetProvider({ children }) {
  const [mode, setMode] = useState(null);
  const [opts, setOpts] = useState({});
  const openAdd = useCallback((m, options = {}) => { setMode(m); setOpts(options); }, []);
  const close = useCallback(() => { setMode(null); setOpts({}); }, []);
  return (
    <Ctx.Provider value={{ openAdd, close }}>
      {children}
      <AddSheet mode={mode} opts={opts} onClose={close} />
    </Ctx.Provider>
  );
}
